var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useFormState } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { SwapButton } from '../../components/SwapButton';
import { useSwapRoutes } from '../../hooks';
import { useSetExecutableRoute } from '../../stores';
import { navigationRoutes } from '../../utils';
export const MainSwapButton = () => {
    const navigate = useNavigate();
    const { isValid, isValidating } = useFormState();
    const setExecutableRoute = useSetExecutableRoute();
    const { routes: swapRoutes, isLoading, isFetching } = useSwapRoutes();
    const currentRoute = swapRoutes === null || swapRoutes === void 0 ? void 0 : swapRoutes[0];
    const handleClick = () => __awaiter(void 0, void 0, void 0, function* () {
        if (currentRoute) {
            setExecutableRoute(currentRoute);
            navigate(navigationRoutes.swapExecution, {
                state: { routeId: currentRoute.id },
            });
        }
    });
    return (_jsx(SwapButton, { onClick: handleClick, currentRoute: currentRoute, disabled: isLoading || isFetching || isValidating || !isValid }));
};
